import { UpdateCoinsModel } from './CustomerService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoinTransaction } from '../models/CoinTransaction';
import { environment } from '../../environments/environment';

export interface AddCoinTransactionModel {
  reflexCustomerNo: number;
  userName: string;
  reasonId: number;
  amount: number;
}

@Injectable()
export default class CoinTransactionService {
  baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
  constructor(private http: HttpClient) {}

  getCoinTransactions(): Observable<CoinTransaction[]> {
    return this.http.get<CoinTransaction[]>(this.baseUrl + 'CoinTransactions');
  }

  getCoinTransactionsByCustomerNo(customerNo: number): Observable<CoinTransaction[]> {
    return this.http.get<CoinTransaction[]>(this.baseUrl + `CoinTransactions/byCustomerNo/${customerNo}`);
  }

  getMyCoinTransactions(): Observable<CoinTransaction[]> {
    return this.http.get<CoinTransaction[]>(this.baseUrl + 'CoinTransactions/me');
  }

  addCoinTransaction(coinTransaction: AddCoinTransactionModel): Observable<CoinTransaction> {
    console.log('Adding coin transaction:', coinTransaction);
    return this.http.put<CoinTransaction>(this.baseUrl + 'CoinTransactions', coinTransaction);
  }
}
